export const SmallOrangeBedIcon = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_16859_70233)">
        <path d="M8.0026 1.33301L14.6693 5.66634V10.333L8.0026 14.6663L1.33594 10.333V5.66634L8.0026 1.33301Z" stroke="#FF9900" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 14.6663V10.333" stroke="#FF9900" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.6693 5.66699L8.0026 10.3337L1.33594 5.66699" stroke="#FF9900" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.33594 10.3337L8.0026 5.66699L14.6693 10.3337" stroke="#FF9900" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 1.33301V5.66634" stroke="#FF9900" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
        <clipPath id="clip0_16859_70233">
            <rect width="16" height="16" fill="white" />
        </clipPath>
    </defs>
</svg>

